import React, {useEffect} from 'react';
import {useRegistry} from "../../../utilities/contexts/registry-context";
import useAsync from "../../../utilities/customHooks/async-call";
import parseOptions from "../../../utilities/data/parseOptions";
import {doGetArticles, doGetSubcontractors, doGetSuppliers} from "../../../logics/registry";
import SearchSelect from "./SearchSelect";

const SelectSupplier = ({value, onChange, ...props}) => {
    const {suppliers, loadSuppliers} = useRegistry();
    const {call} = useAsync();

    const getOptions = () => {

        return suppliers.length > 0
            ?suppliers.map(supplier => parseOptions.parseSupplier(supplier))
            :[];
    }

    const handleChange = (val) => {
        console.log(val);
        onChange && onChange(val);
    }

    useEffect(() => {
        const load = async () => {
            if(!suppliers || !suppliers.length > 0) {
                await call(
                    () => doGetSuppliers(),
                    (res) => {
                        console.log(res);
                        loadSuppliers(res);
                    }
                )
            }
        }
        load();
    }, []);

    return (
        <SearchSelect options={getOptions()} value={parseOptions.parseSupplier(value)} onChange={handleChange}/>
    );
};

export default SelectSupplier;